import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';

const extendToken = store => async (state, token, platform) => {
    const userClientId = state.user.selectedUserClientId;

    const response = await sportsApi
        .url('/social-account-access-tokens')
        .query({ token, platform })
        .get()
        .json();

    store.setState(
        R.assocPath(
            [
                'clients',
                userClientId,
                'socialAccounts',
                platform,
                'accessToken',
            ],
            response.accessToken,
            store.getState(),
        ),
        true,
    );
};

export default extendToken;
